<template>
    <div class="product-slide" ref="slideWrapper">
        <div class="product-item">
            <div class="select-btn" ref="selectBtn" @click.stop="event_changeSelectStatus">
                <i class="iconfont icon-select"
                   :class="productInfo.isChecked === 1 ? 'icon-xuanzhong' : 'icon-weixuanze'"></i>
            </div>
            <div class="product-img">
                <a :href="productAddress">
                    <img :src='image'>
                    <div class="img-bg"></div>
                </a>
            </div>
            <div class="product-info">
                <p class="brand-name">
                    <a :href="productAddress">{{productInfo.brandEnName}}/{{productInfo.brandChName}}</a>
                </p>
                <p class="product-name">
                    <a :href="productAddress">{{productInfo.name}}</a>
                </p>
                <p class="product-spec">
                    <a :href="productAddress">
                        <span v-if="productInfo.color">颜色: {{productInfo.color}}</span>
                        <span v-if="productInfo.size">尺码: {{productInfo.size}}</span>
                    </a>
                </p>
                <div class="product-tags">
                    <!--只有降价显示为黑色，其他的都显示为寺库的主黄色-->
                    <span :data-tag="`已降${productInfo.cutPrice}`" class="tag" style="background-color: #1C1717;" v-if="productInfo.colorMap.cutPriceColor">已降{{productInfo.cutPrice}}元</span>
                    <span data-tag="特例品" class="tag" v-if="productInfo.colorMap.specialColor">特例品</span>
                    <span data-tag="仅剩一件" class="tag" v-if="productInfo.colorMap.lastOneColor">仅剩一件</span>
                    <span data-tag="海外" class="tag" v-if="productInfo.colorMap.abroadColor">海外</span>
                    <span data-tag="手机专享" class="tag" v-if="productInfo.colorMap.activityExclusiveColor">手机专享</span>
                    <span data-tag="预售" class="tag" v-if="productInfo.colorMap.presaleColor">预售</span>
                </div>
                <div class="price-info">
                    <div class="product-price">
                        <span class="integer">￥{{currencyPrice}}</span>
                    </div>
                    <div class="num-btn">
                        <div @click.stop="event_subtract" class="iconfont icon-jianshao subtract" :class="{'disabled': productInfo.quantity <= 1}"></div>
                        <div class="num">{{productInfo.quantity}}</div>
                        <div @click.stop="event_add" class="iconfont icon-tianjia add" :class="{'disabled': productInfo.quantity >= productInfo.inventory}"></div>
                    </div>
                </div>
            </div>
            <div class="right-btns" ref="rightBtns">
                <!--M站不做收藏功能-->
                <!--<div @click.stop="event_addToFavorite" class="collect-btn">移入<br />收藏</div>-->
                <div @click.stop="event_delete" class="delete-btn">删除</div>
            </div>
        </div>
    </div>

</template>

<script>
    import BScroll from 'better-scroll';

    import {
        api_changeSelectStatus,
        api_changeProductQuantity,
        api_deleteProduct,
        api_addToFavorite
    } from '@/api';

    import {handleResCartData} from '@/public/js/public.js';

    const SEC = require('common/js/utils/core.js');

    export default {
        props: {
            productInfo: {
                type: Object,
                default: {}
            }
        },
        data () {
            return {
                scroll: null
            };
        },
        computed: {
            // 图片加工
            image () {
                const image = this.productInfo.image;
                return image && `//pic.secoo.com/product/240/240/${image}`;
            },
            // 价格货币化
            currencyPrice () {
                const {secooPrice} = this.productInfo;
                const reg = /\./;
                let currencyPrice = reg.test(secooPrice)
                    ? SEC.number.currency(secooPrice, 2)
                    : SEC.number.currency(secooPrice);
                return currencyPrice;
            },
            productAddress () {
                const {productId} = this.productInfo;
                return `//m.secoo.com/proDetail_1217.html?prodId=${productId}`;
            }
        },
        mounted () {
            this._initScroll();
        },
        methods: {
            _initScroll () {
                const _this = this;
                // 初始化scroll
                _this.scroll = new BScroll(_this.$refs.slideWrapper, {
                    scrollX: true,
                    // 四边的回弹效果
                    bounce: {
                        top: false,
                        bottom: false,
                        left: false,
                        right: false
                    },
                    // 当快速在屏幕上滑动一段距离的时候，会根据滑动的距离和时间计算出动量，并生成滚动动画。设置为 true 则开启动画。
                    momentum: false
                });
                // 监听滚动结束的事件获取滚动方向
                _this.scroll.on('scrollEnd', function () {
                    const direction = _this.scroll.directionX;
                    if (direction === 1) { // 从左向右滑
                        // 显示右侧的移入收藏和删除按钮
                        _this.scroll.scrollToElement(_this.$refs.rightBtns, 200);
                    } else if (direction === -1) {
                        // 隐藏右侧的移入收藏和删除按钮
                        _this.scroll.scrollToElement(_this.$refs.selectBtn, 200);
                    }
                });
            },
            _changeProductQuantity (itemKey, quantity) {
                const _this = this;
                api_changeProductQuantity(itemKey, quantity).then(({data}) => {
                    const {retCode, cart} = data;

                    if (retCode === 0) {
                        handleResCartData(cart);
                    }
                });
            },
            // 修改商品选中的状态
            event_changeSelectStatus () {
                const _this = this;
                let {isChecked, areaType, packageId, productId, quantity, type} = _this.productInfo;
                let choseProductInfo = [];
                isChecked = isChecked === 1 ? 0 : 1;
                choseProductInfo[0] = {
                    areaType,
                    packageId,
                    productId,
                    quantity,
                    type
                };

                choseProductInfo = JSON.stringify(choseProductInfo);
                api_changeSelectStatus(choseProductInfo, isChecked).then(({data}) => {
                    const {retCode, cart} = data;

                    if (retCode === 0) {
                        handleResCartData(cart);
                    }
                });
            },
            // 移入收藏(M站不做)
            // event_addToFavorite () {
            //
            //     const {productId, nowPrice} = this.productInfo;
            //     console.log(productId, nowPrice);
                // api_addToFavorite(productId, nowPrice).then(({data}) => {
                //     const {retCode, retMsg} = data;
                //     console.log(data);
                //     if (retCode === 0) {
                //         alert('收藏成功');
                //     }
                // });
            // },
            // 删除商品
            event_delete () {
                const _this = this;
                const {itemKey} = _this.productInfo;
                api_deleteProduct(itemKey).then(({data}) => {
                    const {retCode, cart} = data;

                    if (retCode === 0) {
                        handleResCartData(cart);
                    }
                });
            },
            // 减少数量
            event_subtract () {

                const _this = this;

                let {quantity, itemKey} = _this.productInfo;
                // 当前库存为1
                if(quantity <= 1) {
                    return;
                }
                quantity = quantity - 1;

                _this._changeProductQuantity(itemKey, quantity);


            },
            // 增加数量
            event_add () {
                const _this = this;
                let {quantity, inventory, itemKey, isCanIncreQuantity} = _this.productInfo;
                // 当前数量大于等于库存数量，或者该商品不可以增加数量，不执行
                if(quantity >= inventory || !isCanIncreQuantity) {
                    return;
                }
                quantity = quantity + 1;

                _this._changeProductQuantity(itemKey, quantity);
            }
            // 跳转商品详情页
            // event_toProductDetail () {
            //     const {productId} = this.productInfo;
            //     window.location.href = `//m.secoo.com/proDetail_1217.html?prodId=${productId}`;
            // }
        }
    }
</script>

<style lang="scss" scoped>
.product-slide {
    overflow: hidden;
}
.product-item {
    position: relative;
    @extend %flex-horizontal;
    @include box-align(center);
    flex-wrap: nowrap;
    width: toRem(880);
    height: toRem(320);
    margin-bottom: toRem(20);
    background-color: $color-white;
    @include border-1px-b(#E1E1E1);
    .select-btn {
        @extend %flex-horizontal;
        @include box-align(center);
        @include box-pack(center);
        width: toRem(80);
        /*flex: 0 0 toRem(80);*/
        height: 100%;
        .icon-select {
            font-size: toRem(34);
        }
    }
    .product-img {
        position: relative;
        width: toRem(220);
        /*flex: 0 0 toRem(220);*/
        height: toRem(220);
        margin-right: toRem(20);
        img {
            width: 100%;
            height: 100%;
        }
        .img-bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            background-color: $color-black;
            opacity: 0.04;
        }
    }
    .product-info {
        width: toRem(430);
        /*flex: 0 0 toRem(430);*/
        height: toRem(220);
        color: $color-black;
        .brand-name, .product-name, .product-spec {
            width: 100%;
            height: toRem(37);
            line-height: toRem(37);
            font-size: toRem(26);
            overflow: hidden;
            @extend %text-ellipsis;
        }
        .brand-name {
            font-family: Futura-Medium;
        }
        .product-name {
            font-family: FuturaLT-Light;
        }
        .product-spec {
            color: #666;
            span {
                font-family: PingFangSC-Light, Futura-Medium;
            }
        }
        .product-spec span:first-child{
            margin-right: toRem(40);
        }
        .product-tags {
            height: toRem(30);
            margin: toRem(10) 0 toRem(22);
            font-size: 0;
            .tag {
                position: relative;
                display: inline-block;
                height: toRem(30);
                padding: 0 toRem(6);
                margin-right: toRem(10);
                font-family: PingFangSC-Light;
                font-size: toRem(20);
                background-color: $color-yellow;
                color: transparent;
                box-sizing: border-box;
                vertical-align: middle;
                line-height: toRem(30);
                /*解决在部分安卓手机下设置字体垂直居中后偏上的问题*/
                &:after {
                    position: absolute;
                    left: 0;
                    top: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    content: attr(data-tag);
                    width: 200%;
                    height: 200%;
                    font-size: toRem(40);
                    transform-origin: 0 0;
                    transform: scale(0.5);
                    color: $color-white;
                }
            }
        }
        .price-info {
            @include box-align(center);
            @extend %flex-horizontal-between;
            .product-price {
                flex: 1;
                height: toRem(48);
                line-height: toRem(48);
                font-size: toRem(34);
                font-family: Futura-Medium;
                color: #000B0B;
                overflow: hidden;
                @extend %text-ellipsis;
                .decimal {
                    font-size: toRem(22);
                }
            }
            .num-btn {
                @extend %flex-horizontal;
                @include box-align(center);
                @include box-pack(space-between);
                flex-wrap: nowrap;
                height: toRem(50);
                width: toRem(160);
                /*padding: 0 toRem(10);*/
                margin-right: toRem(30);
                @include border-1px($color-gray);
                @include box-sizing(border-box);
                .subtract, .add {
                    /*width: toRem(25);*/
                    font-family: Futura-Medium;
                    height: 100%;
                    line-height: toRem(48);
                    font-size: toRem(28);
                    text-align: center;
                    color: #1A191E;
                    &.disabled {
                        color: $color-gray;
                    }
                }
                .subtract {
                    padding-left: toRem(10);
                }
                .add {
                    padding-right: toRem(10);
                }
                .num {
                    width: toRem(80);
                    height: 100%;
                    font-family: Futura-Medium;
                    font-size: toRem(26);
                    overflow: hidden;
                    @extend %text-ellipsis;
                    background-color: #FFF;
                    line-height: toRem(48);
                    text-align: center;
                }
            }
        }
    }

    .right-btns {
        height: 100%;
        width: toRem(130);
        @extend %flex-horizontal;
        .delete-btn {
            @extend %flex-horizontal;
            @include box-align(center);
            @include box-pack(center);
            width: toRem(130);
            height: 100%;
            line-height: toRem(33);
            font-family: PingFangSC-Medium;
            font-size: toRem(24);
            color: #FFF;
            background-color: $color-black;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsItem/index.vue